import type { RequestResult } from 'interfaces/api/client';
import type { UploadEvents, UploadFileResult } from 'services/api/types';

import { BaseApi } from '../base-api';

export class LogoApi extends BaseApi {
  uploadImage = (attachment: File, options?: UploadEvents): Promise<RequestResult<UploadFileResult>> => {
    const data = new FormData();
    data.append('image', attachment);

    return this.upload('previews/logo', data, {}, options);
  };
}
